export const formatCpf = (cpf: string) => {
  const cleaned = cpf.replace(/\D/g, '');
  return cleaned.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
};

export const formatCnpj = (cnpj: string) => {
  const cleaned = cnpj.replace(/[^0-9A-Za-z]/g, '');
  return cleaned.replace(
    /^([0-9A-Za-z]{2})([0-9A-Za-z]{3})([0-9A-Za-z]{3})([0-9A-Za-z]{4})(\d{2})$/,
    '$1.$2.$3/$4-$5',
  );
};

export const formatPhone = (phone: string) => {
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})$/, '($1) $2 $3-$4');
};